import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai"; // Import close icon
import { useNavigate } from "react-router-dom";

const ExpiredlinkPage = () => {
    const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 container-xxl">
      <div
        className="card text-center p-6 shadow-lg"
        style={{ maxWidth: "800px" }}
      >
        {/* Red Close Icon */}
        <div style={{width:"100%",display:"flex", justifyContent:"center",alignItems:"center"}}>
        <AiOutlineCloseCircle className="text-danger" size={120} />
        </div>
        {/* Title */}
        <h2 className="mt-3" style={{fontSize:"25px"}}>Link Expired</h2>

        {/* Description */}
        <p className="text-muted" style={{fontSize:"20px"}}>
          To reset your password, return to the login page and select{" "}
          <strong>"Forgot Your Password"</strong> to send a new email.
        </p>

        {/* Button */}
        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate("/account-login")}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ExpiredlinkPage;
